import React from 'react';
import { Link } from 'react-router-dom';
import { DirectoryCountryRow } from '../../types';
import { useLocale } from '../../context/LocaleContext';

interface ExploreIndexProps {
  countries: DirectoryCountryRow[];
}

const ExploreIndex: React.FC<ExploreIndexProps> = ({ countries }) => {
  const { locale } = useLocale();
  const isEn = locale === 'en';

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-8">
      {countries.map((country) => {
        const countryName = isEn ? country.nameEn : country.name;
        const attractionsLabel = isEn ? 'attractions' : '个景点';
        return (
          <section key={country.id}>
            <Link
              to={`/${locale}/country/${country.id}`}
              className="dir-link group flex items-baseline gap-2 font-medium"
            >
              <span>{country.flag}</span>
              <span className="group-hover:text-[var(--dir-coral)]">{countryName}</span>
              <span className="text-sm font-normal text-[var(--dir-muted)]">
                {country.attractionCount} {attractionsLabel}
              </span>
            </Link>
            <ul className="mt-2 ml-7 space-y-1 text-sm">
              {country.cities.slice(0, 8).map((city) => (
                <li key={city.slug} className="flex justify-between gap-2 dir-row-hover -mx-2 px-2 py-0.5 rounded">
                  <Link
                    to={`/${locale}/country/${country.id}#city-${city.slug}`}
                    className="dir-link flex-1 truncate"
                  >
                    {isEn ? city.nameEn || city.name : city.name}
                  </Link>
                  <span className="text-[var(--dir-muted)] tabular-nums shrink-0">
                    {city.attractionCount} →
                  </span>
                </li>
              ))}
              {country.cities.length > 8 && (
                <li className="text-[var(--dir-muted)]">
                  <Link to={`/${locale}/country/${country.id}`} className="dir-link-coral text-sm">
                    {isEn ? `+${country.cities.length - 8} more cities` : `还有 ${country.cities.length - 8} 个城市`}
                  </Link>
                </li>
              )}
            </ul>
          </section>
        );
      })}
    </div>
  );
};

export default ExploreIndex;
